import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { GET_ADMIN_MEMBERSHIP, GET_ADMIN_MEMBERSHIP_SUCCESS, GET_ADMIN_MEMBERSHIP_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getAdminMembershipsData({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/admin/memberships`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        'Project-Code': 'MASTERCARD_KSA',
        // ...customHeaders,
      },
      params: {
        ...payload.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_ADMIN_MEMBERSHIP_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_ADMIN_MEMBERSHIP_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_ADMIN_MEMBERSHIP_ERROR, payload: error });
  }
}

export function* watchGetAdminMembershipsData() {
  yield takeEvery(GET_ADMIN_MEMBERSHIP, getAdminMembershipsData);
}

function* getAdminMembershipsDataSaga() {
  yield all([fork(watchGetAdminMembershipsData)]);
}

export default getAdminMembershipsDataSaga;
